<template>
    <div class='drag-layout-tabs-content1'>
        <Tabs v-if = 'tabConf'>
            <TabPane style = 'height:500px;overflow:auto;'  :key = 'index' v-for = '(item,index) in tabConf.Parameter.colList' class = 'tab-item clear-fix' :label="item.title">
                <component :tit = '(fieldTitList[com.componentCode] || "")' v-if = '(com.componentType != "3")||(com.fieldsType=="groupTitle")||fieldList[com.componentCode]'  :ref = 'com.componentCode' :key = 'com.tenantId' :is = 'getComponent(com)' :conf = 'com' v-for = 'com in item.children' />
            </TabPane>>
        </Tabs>
    </div>
</template>
<script>
import getComponent from './getComponent.js';
export default {
    data(){
        return {} 
    },
    mounted() {
      console.log(this.fieldList)
      console.log(this.tabConf.Parameter.colList)
    },
    methods:{
        getFieldData(){
            let datas = {};
            if(this.tabConf&&this.tabConf.Parameter&&this.tabConf.Parameter.colList){
                let {colList} = this.tabConf.Parameter;
                for(let i in colList){
                    for(let j in colList[i].children){
                        if(colList[i].children[j].componentType === '3'){
                            datas[colList[i].children[j].componentCode] = this.$refs[colList[i].children[j].componentCode][0].data;
                        }
                    }
                }
            }
            return datas;
        },
        setFieldData(datas){
            if(this.tabConf&&this.tabConf.Parameter&&this.tabConf.Parameter.colList){
                let {colList} = this.tabConf.Parameter;
                for(let i in colList){
                    for(let j in colList[i].children){
                        for(let k in datas){
                            if(colList[i].children[j].componentType === '3'&&colList[i].children[j].componentCode == k){
                                this.$refs[colList[i].children[j].componentCode]&&(this.$refs[colList[i].children[j].componentCode][0].data = datas[k]);
                            }
                        }
                    }
                }
            }
        },
        getComponent
    },
    props: {
        tabConf: Object,
        fieldList: Object,
        fieldTitList: Object
    },
    components: {}
}
</script>
<style lang = 'less'>
.drag-layout-tabs-content1{
    margin:10px 0;
    .ivu-tabs{
      background: #fff;
    }
    .tab-item{
        background: #fff;
        padding:20px;
    }
    .ivu-tabs-tab{
      padding-top:24px!important;
      padding-left:24px!important;
      padding-right:24px!important;
    }
    /* .ivu-tabs-ink-bar-animated{
      background:#fff!important;
    }
    .ivu-tabs-ink-bar{
      background:#fff!important;
    }
    .ivu-tabs-tab-active{
      background:#fff!important;
    }
    .ivu-tabs-bar{
      margin-bottom:0;
    }
    .ivu-tabs-tab{
        background:#F7F9FC;
        border:none!important;
        margin-right:2px!important;
    } */
}
.clear-fix:after{
	content:'';
	height:0;
	display:block;
	clear:both;
	overflow:hidden;
	visibility:hidden;
}
</style>